import React, { useState } from 'react';
import Swal from 'sweetalert2';

function RegisterUser() {
  const initialFormState = {
    first_name: '',
    middle_name: '',
    last_name: '',
    username: '',
    email: '',
    password: '',
    employee_id: '',
    role: 'standard',
  };

  const [form, setForm] = useState(initialFormState);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const response = await fetch('https://api.stitchtechsolutions.com/api/register_user.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(form),
    });

    const result = await response.json();

    if (result.status === 'success') {
      Swal.fire('Success!', result.message, 'success');
      setForm(initialFormState); // Reset form
    } else {
      Swal.fire('Error', result.message || 'Registration failed.', 'error');
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <h2>Register New User</h2>
      <input name="first_name" type="text" placeholder="First Name" value={form.first_name} onChange={handleChange} required />
      <input name="middle_name" type="text" placeholder="Middle Name" value={form.middle_name} onChange={handleChange} />
      <input name="last_name" type="text" placeholder="Last Name" value={form.last_name} onChange={handleChange} required />
      <input name="employee_id" type="text" placeholder="Employee ID" value={form.employee_id} onChange={handleChange} required />
      <input name="username" type="text" placeholder="Username" value={form.username} onChange={handleChange} required />
      <input name="email" type="email" placeholder="Email" value={form.email} onChange={handleChange} required />
      <input name="password" type="password" placeholder="Password" value={form.password} onChange={handleChange} required />
      <select name="role" onChange={handleChange} value={form.role}>
        <option value="standard">Standard User</option>
        <option value="admin">Admin</option>
      </select>
      <button type="submit">Register</button>
    </form>
  );
}

export default RegisterUser;
